import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import Media from 'react-media';
import { Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { fetchNewsItem } from '../../redux/actions';
import { selectHydrated } from '../../redux/modules/news/selectors';
import { verboseDate } from '../../utils/date';

import NewsIndex from './NewsIndex';

class Details extends PureComponent {
  static propTypes = {
    item: PropTypes.object
  };

  state = {
    loading: true
  };

  fetchItem = id => {

    const p = this.props.fetchNewsItem(id);
    if (p) {
      !this.state.loading && this.setState({loading: true});
      p.then(_ =>  this.setState({loading: false}));
    } else {
      this.state.loading && this.setState({loading: false});
    }
  }

  componentWillMount() {
    this.fetchItem(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps)  {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.fetchItem(nextProps.match.params.id);
    }
  }

  renderItem = () => {
    const {item: {title, publishAt, body }} = this.props;
    return (
      <div>
        <h1 className="mb-4">{title}</h1>
        <span className="date">{verboseDate(publishAt)}</span>
        <div className="body" dangerouslySetInnerHTML={{__html: body}} />
      </div>
    )
  }

  render() {
    const { item } = this.props;
    const { loading } = this.state;
    return (
      <Loader loaded={!loading && !!item}>
        <Media query={{ maxWidth: 575 }}>
          {matches => matches ? (
            <div className="row">
              <div className="col-12">
                {item && this.renderItem()}
                <Link className="btn btn-outline-success btn-block mb-3" to="/news">
                  Atgriezties uz jaunumu sarakstu
                </Link>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-8">
                {item && this.renderItem()}
              </div>
              <div className="col-4">
                {item && (
                  <div className="ml-3">
                    <NewsIndex parent={item.id} history={this.props.history} />
                  </div>)
                }
              </div>
            </div>          
          )}
        </Media>
      </Loader>
    )
  }
}

const mapStateToProps = (state, {match: {params: {id}}}) => ({
  item: selectHydrated(state, id)
});

export default connect(mapStateToProps, {fetchNewsItem})(Details);


// WEBPACK FOOTER //
// ./src/scenes/News/Details.js